
import featureComponent from '@/mixins/featureComponent'

export default {
  name: 'SelectComponent',
  mixins: [featureComponent],
  props: {
    errorMessages: {
      type: Array,
      default: () => [],
    },
  },
}
